import { Link } from "react-router-dom";
import { useSite } from "@/lib/useSite";
import { BOOKING_URL } from "@/lib/booking";
import { BrandLogo } from "@/components/BrandLogo";
import { Facebook, Instagram } from "lucide-react";


export function Footer() {
  const { settings } = useSite();
  const col = "text-[11px] uppercase tracking-[0.18em] text-white/55 hover:text-[#E5B869] transition-colors duration-300";
  const socialIcon = "inline-flex h-8 w-8 items-center justify-center text-white/65 transition-colors duration-300 hover:text-[#E5B869]";
  const goHome = () => window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#08090B] text-white">
      <div className="px-6 sm:px-10 lg:px-16 py-16 grid md:grid-cols-3 gap-10 items-start">
        <div className="leading-tight">
          <Link to="/" onClick={goHome} data-testid="footer-logo" aria-label="Mandalay Real Estate Media home" className="block h-20 w-[230px]">
            <BrandLogo location="footer" />
          </Link>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3 md:justify-center">
          <Link to="/services" data-testid="footer-real-estate-link" className={col}>Real Estate Media</Link>
          <Link to="/web-design" data-testid="footer-web-design-link" className={col}>Web Design & Digital Solutions</Link>
          <Link to="/weddings-events" data-testid="footer-weddings-link" className={col}>Weddings & Events</Link>
          <Link to="/work" data-testid="footer-work-link" className={col}>Portfolio</Link>
          <a href={BOOKING_URL} data-testid="footer-book-link" className={col}>Book Now</a>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3 md:justify-end">
          <div data-testid="footer-social-icons" className="flex items-center gap-2">
            <a href={settings.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className={socialIcon}><Instagram aria-hidden="true" size={18} strokeWidth={1.5} /></a>
            <span role="img" aria-label="Facebook" title="Facebook" data-testid="footer-facebook" className={socialIcon}><Facebook aria-hidden="true" size={18} strokeWidth={1.5} /></span>
          </div>
          <Link to="/login" data-testid="footer-client-login" className={col}>Client Login</Link>
        </div>
      </div>
      <div className="px-6 sm:px-10 lg:px-16 py-5 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 text-[10px] text-white/35 tracking-[0.12em] uppercase">
        <div className="flex gap-6">
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white transition-colors">Terms</Link>
        </div>
        <span>© {new Date().getFullYear()} Mandalay Real Estate Media</span>
      </div>
    </footer>
  );
}
